import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import $ from "jquery";
import { loader_image } from "../_components/Imagepath";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {base_url, Apitoken, Authtoken  } from "../Global";
import {MaterialReactTable} from 'material-react-table';


const SoldesSupplier = () => {
  const [menu, setMenu] = useState(false);
  // const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [datacount, setDatacount] = useState({});
  const [permission, setPermission] = useState({});

  const [paymentslists, setPaymentslists] = useState([]);
  
       let season_id = localStorage.getItem("season_id");
          let parameter =   {
          season_id: season_id,
          
        };

  useEffect(() => {
        setPermission(FindModuleById(201)); 
      console.log(permission);


     axios
      .post(
        "/trader-farmer-supplier-cost-new",
        parameter,
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        setDatacount(response.data.data.overview);
        setDataa(response.data.data.suppliers);
        setPaymentslists(response.data.data.payments);
      })
      .catch((error) => {
        console.log(error);
      });



  }, []);




  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  
  

  const SupplierCell = ({ row }) => (
    <a href={`/supplier-balances-detail/${row.original.supplier_id}`} className="">
      {row.original.supplier_name || ""}
    </a>
  );
  
  SupplierCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        supplier_id: PropTypes.number,
        supplier_name: PropTypes.string,
      }),
    }),
  };
  
  const TotalAmountCell = ({ row }) => (
      <div>{Number(row.original.sum_final_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</div>

  );
  
  TotalAmountCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        sum_final_amount: PropTypes.number,
      }),
    }),
  };
  
  const PaidAmountCell = ({ row }) => (
          <div>{Number(row.original.sum_final_payment_1_2).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</div>
  );
  
  PaidAmountCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        sum_final_payment_1_2: PropTypes.number,
      }),
    }),
  };
  
  const OpenAmountCell = ({ row }) => (
      <div>{Number(row.original.situation).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</div>
  );
  
  OpenAmountCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        situation: PropTypes.number,
      }),
    }),
  };
    const TotalWeight = ({ row }) => (
  <div>{Number(row.original.total_bl_wet_weight).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} KG</div>
  );
  
  TotalWeight.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        total_bl_wet_weight: PropTypes.number,
      }),
    }),
  };  
  const columnss = [
    {
      header: 'Supplier',
      accessorKey: 'supplier_name',
      Cell: SupplierCell,
    },
    {
      accessorKey: 'number_of_receiption',
      header: 'No of Receiption',
    },
    // {
    //   accessorKey: 'total_bl_wet_weight',
    //   header: 'Total BL Net Weight',
    // },
     {
    header: 'Total Net Weight',
    accessorKey: 'total_bl_wet_weight', // Changed from accessorFn
    Cell: TotalWeight,
  },
    {
      header: 'Total Amount',
      // accessorFn: (row) => row.sum_final_amount, 
      accessorKey: 'sum_final_amount', // Changed from accessorFn
      Cell: TotalAmountCell,
    },
    {
      header: 'Paid Amount',
      //accessorFn: (row) => row.sum_final_payment_1_2, 
      accessorKey: 'sum_final_payment_1_2', // Changed from accessorFn
      Cell: PaidAmountCell,
    },
    {
      header: 'Open Amount',
      //accessorFn: (row) => row.situation, 
      accessorKey: 'situation', // Changed from accessorFn
      Cell: OpenAmountCell,
    },
  ];    
  


   const columnspayments =
   [
  
     {
       header: 'Supplier',
       accessorFn: (row) => `${(row.supplier_details)?row.supplier_details.name:""} `,
     },
 
     {
       accessorKey: 'date', //normal accessorKey
       header: 'Date',
     },
 
 
     {
       accessorKey: 'cost', //normal accessorKey
       header: 'Amount',
     },
     {
       header: 'Payment Type',
       accessorFn: (row) => `${(row.paymenttype)?row.paymenttype.title:""} `,
     },
   
     {
       accessorKey: 'note', //normal accessorKey
       header: 'Note',
     },
  
    ];
 
 


  
    const downloadPDF = (e) => {
           let season_id = localStorage.getItem("season_id");
      console.log(e);
      $("#loader-image").removeClass('loader-hide').addClass('loader-show');
  
      axios.get(`/supplier-balances-pdf?season_id=${season_id}`, {
          responseType: 'blob',
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'SUPPLIER BALANCE.pdf';
          link.click();
          
          $("#loader-image").removeClass('loader-show').addClass('loader-hide');
      })
      .catch(error => {
          console.error('Error downloading PDF:', error);
          $("#loader-image").removeClass('loader-show').addClass('loader-hide');
      });
  };
  
      const downloadExcel = (e) => {
        console.log(e);
            let season_id = localStorage.getItem("season_id");
        $("#loader-image2").removeClass('loader-hide2');
        $("#loader-image2").addClass('loader-show2');
        window.open(`${base_url}/supplier-balances-excel?season_id=${season_id}`, '_blank');
        $("#loader-image2").addClass('loader-hide2');
        $("#loader-image2").removeClass('loader-show2');
      }
  
 
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Supplier&apos;s Balance</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">Supplier&apos;s Balance Listing</li>
                  </ul>
                </div>
               
              </div>
            </div>
            
            <div className="row">
                
              <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                <div className="card inovices-card w-100">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <div className="dash-count">
                        <div className="dash-title"> Total Amount</div>
                        <div className="dash-counts">
                          <p>{datacount.tab_total_amount}dh</p>
                        </div>
                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                <div className="card inovices-card w-100">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <div className="dash-count">
                        <div className="dash-title"> Paid Amount</div>
                        <div className="dash-counts">
                        <p>{datacount.tab_paid_amount}dh</p>
                        </div>
                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                <div className="card inovices-card w-100">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <div className="dash-count">
                        <div className="dash-title"> Open </div>
                        <div className="dash-counts"> <p>{datacount.tab_open_amount}dh</p>
                        </div>

                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>
                    
              </div>
           
          
            <div className="row">
               <div className="col-sm-12" >
              <section className="comp-section">
              
              <div className="row">
              <div className="col-md-12">
                 {permission && permission.list == 1 && (
                  <div className="col-auto" style={{float:'right', paddingBottom:'30px'}}>
                        <button
                          className="btn btn-primary"
                          onClick={() => downloadPDF()}
                        >
                          <i className="fas fa-file-pdf font-24" ></i>  <img id="loader-image" className="loader-image loader-hide" src={loader_image}/> 
                        </button>  
                        &nbsp;&nbsp;
                        <button
                          className="btn btn-primary"
                          onClick={() => downloadExcel()}
                        >
                          <i className="fas fa-file-excel	font-24"></i> <img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/>
                        </button>   
                    </div>
                 )}
              
              </div>
              <div className="col-md-12">
                    {permission && permission.list == 1 && (
                         <div className="card bg-white">
                                                 
                            <div className="card-body">
                                <ul className="nav nav-tabs nav-tabs-bottom">
                                
                              
                                <li className="nav-item">
                                    <a className="nav-link active" href="#listing-groupby-supplier" data-bs-toggle="tab">Group By Supplier</a>                                  
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link " href="#listing-all" data-bs-toggle="tab"> Payments</a>                                   
                                </li>  
                                                  
                                </ul>
                                <div className="tab-content">
                              
                                <div className="tab-pane show active" id="listing-groupby-supplier">
                                <div className="row"   id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                          <div className="table-responsive">

                                          <MaterialReactTable columns={columnss} data={dataa} 
                                            enableColumnOrdering
                                            enableColumnFilterModes
                                            enablePinning
                                            initialState={{
                                              pagination: {
                                                pageSize: 50,   // default rows per page
                                                pageIndex: 0,   // start from first page
                                              },
                                            }}
                                          />
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                  
                                  </div>                                
                                  <div className="tab-pane  " id="listing-all">
                                    <div className="row"   id="listing-followup">
                                      <div className="col-sm-12">
                                        <div className="card card-table">
                                          <div className="card-body">
                                              <div className="table-responsive">
                                              <MaterialReactTable columns={columnspayments} data={paymentslists} 
                                                    enableColumnFilterModes
                                                    enableColumnOrdering
                                                    // enableGrouping
                                                    
                                                  
                                                  />
                                              
                                              </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  
                                  </div>                                
                                                        
                                
                                </div>                             
                            </div>
                            </div>
                       )}
                    </div>
                    </div>
                </section>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
};
export default SoldesSupplier;
